export const ActionsButtonStyleValues = { width: '12rem' }
